import { atom } from "recoil"

export const attendanceAnswerCsvDataRequestIdState = atom<number>({
  key: "atoms/csvData/attendanceAnswerCsvDataRequestIdState",
  default: 0,
})
